<template>
  <div>
    <div class="q-mt-xl col-12">
      <div
        class="row col-12 text-brand-5 text-subtitle1 text-weight-bold titulo-tabela"
      >
        Todos os Produtos Criados
      </div>
      <div
        class="row col-12 items-center justify-between text-brand-5 text-weight-bold q-mb-lg q-ml-md container-input-search"
      >
        <div class="mobile q-mr-md">
          <q-btn
            icon="check_circle_outline"
            class="btn-mobile"
            color="positive"
            no-caps
            dense
            label="Vincular a Produto"
            @click="associarCas()"
          />
        </div>
        <div class="row col-md-12 col-xs justify-end">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="busca"
            type="text"
            class="col-md-3 col-xs"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaProdutos"
        color="primary"
        row-key="id"
        dense
        table-header-class="bg-accent text-weight-bold"
        hide-pagination
        class="tabela-tamanho-fixo"
        hide-bottom
        v-model:pagination="pagination"
        :loading="loading"
        @request="paginarTabela"
        :grid="$q.screen.lt.sm"
        flat
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5">
              <div
                class="row col-12 text-grid-table items-center q-mb-xs justify-between q-px-sm q-pt-sm"
              >
                <div><strong>ID: </strong>{{ props.row.id }}</div>
                <div><strong>Código: </strong>{{ props.row.code }}</div>
                <div>
                  <strong>CA Atual: </strong>{{ props.row.pivot.ca?.code }}
                </div>
              </div>
              <div class="col-12 q-mb-xs q-px-sm">
                <strong>Nome: </strong
                >{{
                  props.row.pivot?.contract_product_description ||
                  props.row.name
                }}
              </div>
              <span class="row col-12 items-center q-mb-xs q-px-sm">
                <strong>Status: </strong>
                <div v-if="props.row.pivot.ca">
                  <div
                    v-if="props.row.pivot.ca?.status == 'Válido'"
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div style="width: fit-content" class="text-brand-5">
                      {{ props.row.pivot.ca?.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 2px"
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div style="width: fit-content">
                      {{ props.row.pivot.ca?.status }}
                    </div>
                  </div>
                </div>
              </span>
              <div class="q-px-sm q-mb-sm">
                <q-icon name="event" class="q-mr-xs" />
                <strong>Vencimento: </strong>
                <span>{{
                  props.row.pivot.ca?.expires_in
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </div>
              <div class="col-12">
                <div class="row">
                  <div
                    class="column col-6 btn-grid-esquerdo"
                    style="background: #58afc1"
                  >
                    <div class="row col-12 justify-center">
                      <q-checkbox
                        v-model="selecionados"
                        size="md"
                        :val="props.row.id"
                        dark
                      />
                      <span
                        class="row col-12 justify-center"
                        style="color: white"
                        ><span>Selecionar</span></span
                      >
                    </div>
                  </div>
                  <div class="column col-6">
                    <q-btn
                      stack
                      flat
                      color="negative"
                      no-caps
                      icon="remove_circle_outline"
                      class="btn-grid-direito"
                      style="height: 100%"
                      @click="desassociarCa(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <q-checkbox
                v-model="selecionados"
                size="sm"
                :val="props.row.id"
                style="margin-left: 20px"
              />
            </q-td>
            <q-td>
              <span>{{ props.row.id }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.code }}</span>
            </q-td>
            <q-td
              style="
                white-space: normal;
                word-break: break-word;
                max-width: 300px;
              "
            >
              <span>{{
                props.row.pivot?.contract_product_description || props.row.name
              }}</span>
            </q-td>
            <q-td>
              <div v-if="props.row.pivot.ca">
                <div
                  v-if="props.row.pivot.ca?.status == 'Válido'"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ props.row.pivot.ca?.status }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ props.row.pivot.ca?.status }}
                  </div>
                </div>
              </div>
            </q-td>
            <q-td>
              <span>{{
                props.row.pivot.ca?.expires_in
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.pivot.ca?.code }}</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="props.row.pivot.ca"
                style="padding: 0px 0px 0px 0px"
                color="negative"
                icon="delete"
                flat
                no-caps
                push
                @click="desassociarCa(props.row.id)"
              >
              </q-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <div class="q-ml-xs q-mt-lg desktop">
      <q-btn
        icon="add"
        class="q-mt-sm btn"
        color="positive"
        no-caps
        label="Vincular a Produto"
        @click="associarCas()"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
const columns = [
  {
    name: "checkbox",
    label: "Vincular a CA",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome do Produto",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "vencimento",
    label: "Vencimento",
    align: "left",
  },
  {
    name: "caativo",
    label: "CA Ativo",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover CA",
    align: "left",
  },
];
export default {
  props: ["ca"],
  emits: ["limpar"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const listaProdutos = ref();
    const selecionados = ref([]);
    let loading = ref(false);
    let disable = ref(false);
    const busca = ref("");

    const listarProdutos = async (page = 1, rowsPerPage = 6) => {
      if (store.state.org.contract == undefined) {
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        let response = await store.dispatch("produtosNovo/listarProdutos", {
          contract_id: store.state.org.contract,
          per_page: rowsPerPage,
          page: page,
          search: busca.value,
        });
        listaProdutos.value = response.data.model.products.data;
        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.page = response.data.model.products.current_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const paginarTabela = async () => {
      listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const associarCas = async () => {
      if (selecionados.value.length == 0) {
        quasar.notify({
          message: "Selecione um produto pelo menos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (props.ca == null) {
        quasar.notify({
          message: "Selecione um CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      const products = [];
      selecionados.value.forEach((produto) => {
        products.push({ product_id: produto, ca_id: props.ca.value });
      });
      try {
        await store.dispatch("produtosNovo/associarCa", {
          catalog_id: recebeUnidade.value.id,
          products: products,
        });
        selecionados.value = [];
        busca.value = "";
        listarProdutos();
        emit("limpar");
        quasar.notify({
          message: "CAs vinculados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao vincular CAs",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desassociarCa = async (id) => {
      const products = [];
      products.push({ product_id: id, ca_id: null });
      try {
        await store.dispatch("produtosNovo/associarCa", {
          catalog_id: recebeUnidade.value.id,
          products: products,
        });
        selecionados.value = [];
        listarProdutos();
        quasar.notify({
          message: "CAs desassociado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao desassociar CAs",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.contract,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => busca.value,
      () => {
        listarProdutos();
      }
    );

    onMounted(listarProdutos);

    return {
      columns,
      listarProdutos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      listaProdutos,
      loading,
      disable,
      busca,
      paginarTabela,
      selecionados,
      associarCas,
      desassociarCa,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.mobile {
  display: none;
}
@media (max-width: 600px) {
  .titulo-tabela {
    display: none;
  }
  .container-input-search {
    margin: 40px 0px;
  }
  .text-grid-table {
    font-size: 13px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px 0px 0px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-esquerdo {
    border-radius: 0px 0px 0px 5px;
    font-size: 12px;
  }
  .btn-grid-direito {
    border-radius: 0px 0px 5px 0px;
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
    margin-bottom: 22px;
  }
  .btn-mobile {
    font-size: 12px;
  }
  .mobile {
    display: block;
  }
  .desktop {
    display: none;
  }
}
</style>
